
// parikshat's edit

var drawer = function () {
    if (!Element.prototype.closest) {
      if (!Element.prototype.matches) {
        Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
      }
      Element.prototype.closest = function (s) {
        var el = this;
        var ancestor = this;
        if (!document.documentElement.contains(el)) return null;
        do {
          if (ancestor.matches(s)) return ancestor;
          ancestor = ancestor.parentElement;
        } while (ancestor !== null);
        return null;
      };  
    }
    var settings = {
      speedOpen: 50,
      speedClose: 350,
      activeClass: 'is-active',
      visibleClass: 'is-visible',
      selectorTarget: '[data-drawer-target]',
      selectorTrigger: '[data-drawer-trigger]',
      selectorClose: '[data-drawer-close]',

    };


    var toggleccessibility = function (event) {
      if (event.getAttribute('aria-expanded') === 'true') {
        event.setAttribute('aria-expanded', false);
      } else {
        event.setAttribute('aria-expanded', true);
      }
    };


    var openDrawer = function (trigger) {
      var target = document.getElementById(trigger.getAttribute('aria-controls'));
      target.classList.add(settings.activeClass);
      document.documentElement.style.overflow = 'hidden';
      toggleccessibility(trigger);


      setTimeout(function () {
        target.classList.add(settings.visibleClass);
      }, settings.speedOpen);
    };

    var closeDrawer = function (event) {
      var closestParent = event.closest(settings.selectorTarget),
        childrenTrigger = document.querySelector('[aria-controls="' + closestParent.id + '"');
      closestParent.classList.remove(settings.visibleClass);
      document.documentElement.style.overflow = '';
      toggleccessibility(childrenTrigger);
      setTimeout(function () {
        closestParent.classList.remove(settings.activeClass);
      }, settings.speedClose);
    };
    var clickHandler = function (event) {
      var toggle = event.target,
        open = toggle.closest(settings.selectorTrigger),
        close = toggle.closest(settings.selectorClose);


      if (open) { openDrawer(open); }
      if (close) { closeDrawer(close); }
      if (open || close) { event.preventDefault(); }
    };


    var keydownHandler = function (event) {
      if (event.key === 'Escape' || event.keyCode === 27) {
        var drawers = document.querySelectorAll(settings.selectorTarget),
          i;
        for (i = 0; i < drawers.length; ++i) {
          if (drawers[i].classList.contains(settings.activeClass)) {
            closeDrawer(drawers[i]);
          }
        }
      }
    };

    document.addEventListener('click', clickHandler, false);
    document.addEventListener('keydown', keydownHandler, false);
};

drawer();



// function to update cart drawe subtotal and count


function updatedrawer(data){
  
  console.log(data);
 var quantity = data.item_count;
 var totalprice = data.items_subtotal_price/100;
  var totaldis = data.total_discount/100;
  $(".cart-count-bubble span:first-child").text(quantity);
  $(".cart__total_price").text( totalprice);
  $(".total_savings .ammount").text(totaldis);
  // Abhishek vaid edit
  document.querySelectorAll('[data-index]').forEach((e,i)=>{
  	e.setAttribute('data-index',i+1)
  })
}

// function to add lineitem
var minussym = '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" fill="none" viewBox="0 0 10 2"><path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"></svg>';
var plussym  = '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" fill="none" viewBox="0 0 10 10"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></svg>'


// Cart line-item images come from /cart.js as full-size originals; request a
// 240px version from the image CDN instead so the drawer renders fast.
function bnsCartThumb(url){
  if (!url || url.indexOf('cdn.shopify.com') === -1) return url;
  return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=240';
}

// Line-level discount on a /cart.js item (e.g. the automatic "15% off on 2 pullovers").
// Returns null when no discount has been applied to that line.
function bnsLineDiscount(item){
  if (!item) return null;
  var op = Number(item.original_price) || 0;
  var fp = Number(item.final_price) || 0;
  if (op <= 0 || fp >= op) return null;
  var qty = Number(item.quantity) || 1;
  var saveTotal = (item.original_line_price != null && item.final_line_price != null)
    ? item.original_line_price - item.final_line_price
    : (op - fp) * qty;
  var title = '';
  var allocs = item.line_level_discount_allocations;
  if (allocs && allocs.length && allocs[0].discount_application && allocs[0].discount_application.title) {
    title = allocs[0].discount_application.title;
  } else if (item.discounts && item.discounts.length && item.discounts[0].title) {
    title = item.discounts[0].title;
  }
  return {
    percent: Math.round((op - fp) * 100 / op),
    title: title,
    saveTotal: saveTotal,
    quantity: qty
  };
}

// Paise -> "2599" / "2209.15". Must match snippets/bns-money.liquid so the first
// (Liquid) render and every JS re-render of the drawer show identical numbers.
function bnsMoney(cents){
  cents = Math.round(Number(cents) || 0);
  return cents % 100 === 0 ? String(cents / 100) : (cents / 100).toFixed(2);
}

function bnsEscape(str){
  return String(str).replace(/[&<>"']/g, function (c) {
    return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
  });
}

function bnsLineOfferHtml(item, currsym){
  var d = bnsLineDiscount(item);
  if (!d) return '';
  return '<div class="bns-line-offer">'
    + '<span class="bns-line-offer__tag">' + d.percent + '% OFF</span>'
    + '<span class="bns-line-offer__text">' + (d.title ? bnsEscape(d.title) : 'Offer applied')
    + '<br><b>You save ' + currsym + ' ' + bnsMoney(d.saveTotal)
    + (d.quantity > 1 ? ' on ' + d.quantity + ' items' : '') + '</b></span>'
    + '</div>';
}

function bnsPriceFieldHtml(item, currsym){
  if (!bnsLineDiscount(item)) {
    return '<p class="a provide_padding"> ' + currsym + ' ' + bnsMoney(item.final_price) + ' </p>';
  }
  return '<p class="a"> <span class="aa">' + currsym + ' ' + bnsMoney(item.original_price) + ' </span> ' + currsym + ' ' + bnsMoney(item.final_price) + ' </p>'
    + ' <p class="b"> You save ' + currsym + ' ' + bnsMoney(item.original_price - item.final_price) + '</p>';
}

// /cart/change only returns cart JSON, so refresh each line's price + offer in place
// (quantity going 1 -> 2 is what switches the pullover discount on or off).
function bnsRefreshLineOffers(data){
  if (!data || !data.items) return;
  var currsym = $("#drawwr_wrapper").attr("data-curr");
  $(".new_cart_drawer .drawer_item").each(function(){
    var item = data.items[parseInt($(this).attr("data-index"), 10) - 1];
    $(this).find(".bns-line-offer").remove();
    if (!item) return;
    $(this).find(".price_field").html(bnsPriceFieldHtml(item, currsym));
    $(this).find(".item_wrap_content").append(bnsLineOfferHtml(item, currsym));
  });
}

function updatelineitem(data){
  var currsym = $("#drawwr_wrapper").attr("data-curr");
  var delsym = $("#drawwr_wrapper").attr("data-del");
  var count = data.items.length;
  var itemdt = data.items;
  if(count>0){
    var i;
  for(i=0 ; i<count ; i++){
    var n = itemdt[i];
    var fp = n.final_price;
    var op = n.original_price;
    var prop = n.properties;
    console.log(prop);
    let proVal='';
    for(let key in prop){
      proVal += `<p class="${key}"> ${key}:${prop[key]}</p>`;
    }
    let div = `<div class="properties">${proVal}</div>`
        console.log('yahan tak pocha')
    $(".cart_items_inner_wrapper").append('<div class="drawer_item is_ajax" data-index="'+(i+1)+'" data-id="'+n.id+'"> <div class="item_inner" data-quan=""> <div class="item_wrap_img"> <a href="'+ n.url +'">  <img src="'+bnsCartThumb(n.image)+'" width="120" height="150" loading="lazy"> </a> </div> <div class="item_wrap_content">  <div class="item_wrap_content_up"> <a href="'+ n.url +'"> <h4> '+ n.title +' </h4></a><img class="del_btn" src="'+delsym+'"></div> <div> '+div+' </div> <div class="item_wrap_content_down"> <div class="quan_selector"> <span data-btn="minus"> '+minussym+' </span> <input type="text" readonly min=1 value="'+n.quantity+'"> <span data-btn="plus"> '+plussym+' </span> </div> <div class="price_field"> '+ bnsPriceFieldHtml(n, currsym) +' </div>  </div> '+ bnsLineOfferHtml(n, currsym) +' </div>  </div> </div>');
  }
}
  // The JS markup above shows instantly; then swap in the server's Liquid render so the
  // drawer after add-to-cart is exactly what a page reload shows (offer message included).
  bnsSyncDrawerFromServer();
}

// Fetch sections/cart-drawer-items.liquid (same snippet the page renders on load) via the
// Section Rendering API and swap the line items in. Checkout buttons are left untouched.
// Only the newest request is applied if several overlap.
var bnsDrawerSyncSeq = 0;
function bnsSyncDrawerFromServer(){
  var seq = ++bnsDrawerSyncSeq;
  if (typeof fetch !== 'function' || typeof DOMParser !== 'function') return Promise.resolve(false);
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  return fetch(root + '?sections=cart-drawer-items', { headers: { Accept: 'application/json' } })
    .then(function (res) { return res.json(); })
    .then(function (json) {
      if (seq !== bnsDrawerSyncSeq || !json || !json['cart-drawer-items']) return false;
      var doc = new DOMParser().parseFromString(json['cart-drawer-items'], 'text/html');
      var fresh = doc.querySelector('#cart__drawer_items');
      var current = document.querySelector('#cart__drawer_items');
      if (!fresh || !current) return false;
      current.innerHTML = fresh.innerHTML;
      var subtotal = doc.querySelector('[data-bns-subtotal]');
      if (subtotal) $(".cart__total_price").text(subtotal.textContent.trim());
      return true;
    })
    .catch(function (err) {
      console.error('Cart drawer server render failed, keeping JS render:', err);
      return false;
    });
}

// check if cart is empty or not

function cartcheck(data){

  var x = data.items.length;
  
  if(x==0){
  
    $(".cart_items_inner_wrapper , .total_price_wrap").css("display","none");
    $(".empty-cart-msg").css("display","block");
  
  }
  else{
  
   $(".cart_items_inner_wrapper , .total_price_wrap").css("display","block");
    $(".empty-cart-msg").css("display","none");
  }

}

// edit for quantity btn

$("body").on("click",".quan_selector span" , function(){
  var x = $(this).attr("data-btn");
  var inp = $(this).parent().find("input");
  var val = $(inp).val();

  if(x=="plus" && parseInt(val ) >= 0){ 
     var nval = parseInt(val ) + 1;
  }
   else if(x=="minus" && parseInt(val ) >= 0){
     var nval = parseInt(val ) - 1;
  }
  var id = $(this).parents(".drawer_item").attr("data-index"); 
  if(nval > 0  ){
   $.ajax({
          type: 'POST',
          url: '/cart/change?line='+id+'&amp;quantity='+nval,
          dataType: 'json',
          success: function(itemData) {
    							 inp.val(nval);
     							 inp.change();
            					 updatedrawer(itemData);
          }
 		  });
  
  } else {
     inp.val(nval);
     inp.change();
    $(this).parents('.drawer_item').find('.del_btn').click();
  }
  

  
});



// edit for del  btn

$("body").on("click" , ".new_cart_drawer .del_btn",function(){

  var id = $(this).parents(".drawer_item").attr("data-index");
  var item = $(this).parents(".drawer_item");
   $.ajax({
          type: 'POST',
          url: '/cart/change?line='+id+'&amp;quantity=0',
          dataType: 'json',
     success: function(itemData) {

       
       item.remove();
       
       updatedrawer(itemData);
       cartcheck(itemData);
     
     }
   
   
   });
            

});


// Drawer open/refresh on add-to-cart now happens in product-form.js AFTER the
// /cart/add request succeeds (window.refreshCartDrawerFallback). The old handler
// here opened the drawer on a fixed 1s timer, which raced the add request and
// showed an empty drawer on slow networks.

// function to close drawer if clicked outside
  $(document).mouseup(function(e) 
{
    var container = $(".new_cart_drawer");

    // if the target of the click isn't the container nor a descendant of the container
    
    if(container.hasClass("is-active")){
      
    
    if (!container.is(e.target) && container.has(e.target).length === 0) 
    {
     $(".drawer__title .goback_link").click();
    }
    
    }
}); 
  


//final  edit end

$("#cart-icon-bubble").on("click", function(){
setTimeout(function(){
   var windowHeight = $(window).height();
   var drawer_foot_area = $(".total_price_wrap").height();
   var setpxItemDrawar1 = windowHeight - drawer_foot_area;
   var setpxItemDrawar = setpxItemDrawar1 - 100;
$("#cart__drawer_items").css("maxHeight",setpxItemDrawar); 
}, 800); 
});



$("body").on("click",".product-form__submit.button", function(){
  
  console.log('ksbvkjsdbkv');
  
  $('.modal__close-button.link').click();
  
   setTimeout(function(){
  
  
  
   var windowHeight = $(window).height();
   var drawer_foot_area = $(".total_price_wrap").height();
   var setpxItemDrawar1 = windowHeight - drawer_foot_area;
   var setpxItemDrawar = setpxItemDrawar1 - 100;
$("#cart__drawer_items").css("maxHeight",setpxItemDrawar); 
}, 4000);
});



 

function updatedrawer(data) {
  console.log(data);
  var quantity = data.item_count;
  var totalprice = bnsMoney(data.items_subtotal_price);
  var totaldis = data.total_discount / 100;
  $(".cart-count-bubble span:first-child").text(quantity);
  $(".cart__total_price").text(totalprice);
  $(".total_savings .ammount").text(totaldis);
  // Abhishek vaid edit
  // Only drawer items: other [data-index] elements on the page (e.g. announcement slides)
  // would shift the line numbers used for /cart/change.
  document.querySelectorAll('.new_cart_drawer .drawer_item').forEach((e, i) => {
    e.setAttribute('data-index', i + 1);
  });
  bnsRefreshLineOffers(data);

  // Check if the cart is empty and close the drawer after a delay
  if (quantity === 0) {
    setTimeout(function () {
      $(".new_cart_drawer").removeClass('is-active is-visible');
      $("html").css("overflow", "");
    }, 800); // Adjust the delay time (in milliseconds) as needed
  }
}

// Click outside to close the drawer
$(document).mouseup(function (e) {
  var container = $(".new_cart_drawer");
  if (container.hasClass("is-active") && !container.is(e.target) && container.has(e.target).length === 0) {
    $(".drawer__title .goback_link").click();
  }
});

// Additional check when the page loads
$(document).ready(function () {
  // Assuming this check is needed when the page initially loads
  var initialQuantity = parseInt($(".cart-count-bubble span:first-child").text());
  if (initialQuantity === 0) {
    setTimeout(function () {
      $(".new_cart_drawer").removeClass('is-active is-visible');
      $("html").css("overflow", "");
    }, 800); // Adjust the delay time (in milliseconds) as needed
  }
});


